import React, {useEffect, useState} from 'react';
import {AppBar, Box, IconButton, Paper, Toolbar, Typography} from '@mui/material';
import MessageInput from '../components/MessageInput';
import MessageList from '../components/MessageList';
import apiService from "../services/api";
import {useNavigate} from 'react-router-dom';
import {ArrowBackIosNew} from "@mui/icons-material";

const transperent = '#03030300';

const ChatPage = ({user}) => {
    const [isWaitingResponse, setIsWaitingResponse] = useState(false);
    const [messages, setMessages] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [conversationEnabled, setConversationEnabled] = useState(false);
    const [conversationData, setConversationData] = useState(null);
    const [sessionId, setSessionId] = useState(window.location.pathname.split('/').pop());
    const [timeLeft, setTimeLeft] = useState(20 * 60); // 20 minutes in seconds
    const navigate = useNavigate();

    const fetchSession = async () => {
        try {
            const session = await apiService.getConversationData(sessionId);
            setConversationData(session);
        } catch (error) {
            console.error('Error fetching session:', error);
            setConversationData(null);
        }
    }

    useEffect(() => {
        if (conversationData) {
            setMessages(conversationData.messages);
            setConversationEnabled(!conversationData.endTime);
            setTimeLeft(conversationData.endTime ? 0 : 20 * 60);
        }
    }, [conversationData]);

    useEffect(() => {
        if (sessionId) {
            fetchSession();
        }
    }, [sessionId]);

    useEffect(() => {
        // Countdown timer for the session
        if (timeLeft > 0 && conversationEnabled) {
            const timer = setInterval(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [timeLeft, conversationEnabled]);

    const handleSendMessage = async () => {
        if (inputValue.trim() === '') return;

        const newMessage = {
            message: inputValue,
            sender: 'user',
            timestamp: {_seconds: Math.floor(Date.now() / 1000)},
        };

        setMessages((prevMessages) => [...prevMessages, newMessage]);
        setInputValue('');
        setIsWaitingResponse(true);
        const answer = await apiService.sendMessage(sessionId, inputValue);
        const {aiResponse} = answer;

        const answerMessage = {
            message: aiResponse,
            sender: 'ai',
            timestamp: {_seconds: Math.floor(Date.now() / 1000)},
        };
        setMessages((prevMessages) => [...prevMessages, answerMessage]);
        setIsWaitingResponse(false);
    };

    const handleBackClick = () => {
        navigate('/home'); // navigate to home page
    };

    const containerStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: `linear-gradient(180deg, rgb(21 0 53 / 89%), rgb(0 116 98 / 84%))`,
        backgroundColor: `${transperent} !important`,
        backgroundSize: '200% 200%',
        direction: 'rtl',
    };

    const chatBoxStyle = {
        maxWidth: '800px',
        width: '100%',
        maxHeight: '900px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '16px',
        overflow: 'hidden',
        backgroundColor: '#00000026 !important',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        position: 'relative',
        direction: 'rtl',
    };

    const calculateProgress = () => {
        const totalSessionTime = 20 * 60; // 20 minutes in seconds
        return ((totalSessionTime - timeLeft) / totalSessionTime) * 100;
    };

    return (
        <Box className="chat-container" sx={containerStyle}>
            <Paper sx={chatBoxStyle}>
                <AppBar position="static" sx={{backgroundColor: '#001E3C'}}>
                    <Toolbar>
                        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
                            {conversationData?.endTime ? 'השיחה הסתיימה' : 'שיחה פעילה'}
                        </Typography>
                        <IconButton edge="start" color="inherit" onClick={handleBackClick}>
                            <ArrowBackIosNew/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <MessageList messages={messages} user={user}/>
                {user && (
                    <MessageInput
                        inputValue={inputValue}
                        setInputValue={setInputValue}
                        handleSendMessage={handleSendMessage}
                        isWaitingResponse={isWaitingResponse}
                        conversationEnabled={conversationEnabled}
                    />
                )}
            </Paper>
        </Box>
    );
};

export default ChatPage;
